var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-page',{attrs:{"title":_vm.$t('SettingsManagement.roleManagement')}},[_c('RoleTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }